// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1cYPf","container":"styles_container__MifHv","title":"styles_title__3mZoD","wrapper":"styles_wrapper__1DzMu","answer":"styles_answer__2dwd8"};